import { Avatar } from "@heroui/react";
import useScreenSize, { ScreenSize } from "@src/presentation/hooks/useScreenSize";
import { Link } from "react-router-dom";

const Logo: React.FunctionComponent = () => {
  const screenSize = useScreenSize();
  const isSmallScreen = screenSize === ScreenSize.Mobile || screenSize === ScreenSize.Tablet;

  if (isSmallScreen) return null;

  return (
    <Link to={"/dashboard"} className="flex items-center gap-2">
      <Avatar size="sm" src="/pascohub_logo.webp" className="bg-primary" classNames={{
        img: 'h-5 w-5'
      }} />
      <div className="relative text-wfp-text font-bold">Peppermin</div>
    </Link>
  );
};

export default Logo;
